export default function collapsibleHandler(delay) {
  const collapsibleTriggers = document.querySelectorAll('.collapsible-trigger');
  const collapsibleClose = document.querySelectorAll('.collapsible-close');
  const smoothScrollSection = (scrollTrigger) => {
    const scrollTarget = scrollTrigger.getAttribute('href');
    document.querySelector(scrollTarget).scrollIntoView({ behavior: 'smooth' });
  };

  collapsibleTriggers.forEach((collapsibleTrigger) => {
    collapsibleTrigger.addEventListener('click', (e) => {
      const collapsibleTriggerParent = collapsibleTrigger.parents('.js-collapsible-wrapper')[0];
      const collapsibleTriggerBtn = collapsibleTriggerParent.querySelector('.section-close');
      e.preventDefault();
      collapsibleTriggerParent.querySelector('.js-collapsible').style.maxHeight = `${collapsibleTriggerParent.querySelector('.js-collapsible').scrollHeight}px`;
      // eslint-disable-next-line no-param-reassign
      collapsibleTrigger.style.display = 'none';
      if (collapsibleTriggerBtn) {
        collapsibleTriggerBtn.style.display = 'inline-block';
      }
      if (collapsibleTriggerParent.querySelector('.js-collapsible').scrollHeight > 1000) {
        smoothScrollSection(collapsibleTrigger);
      }
    });
  });

  collapsibleClose.forEach((closeBtn) => {
    closeBtn.addEventListener('click', (e) => {
      const closeBtnParent = closeBtn.parents('.js-collapsible-wrapper')[0];
      const collapsibleCloseBtn = closeBtnParent.querySelector('.section-close');
      e.preventDefault();
      smoothScrollSection(closeBtn);
      setTimeout(() => {
        closeBtnParent.querySelector('.js-collapsible').style.maxHeight = '0px';
        // eslint-disable-next-line no-param-reassign
        closeBtnParent.querySelector('.collapsible-trigger').style.display = 'inline-block';
        if (collapsibleCloseBtn) {
          collapsibleCloseBtn.style.display = 'none';
        }
      }, delay);
    });
  });
}
